<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'input',
  },
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  help: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: null,
  },
  iconLeft: {
    type: Boolean,
    default: false,
  },
  iconRight: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: null,
  }
});
</script>

<template>
  <div class="sy-input-wrap" :class="size">
    <UiLabel v-if="props.label" :required="props.required" :help="props.help">{{ props.label }}</UiLabel>
    <div class="sy-input-content" :class="[{'icon-left' : iconLeft}, {'icon-right' : iconRight}]">
      <slot></slot>
      <div v-if="$slots.rightText" class="sy-input-action">
        <slot name="rightText"></slot>
      </div>
    </div>
    <p v-if="props.message" class="help-message">{{ props.message }}</p>
  </div>
</template>